import React from 'react';

import { Stack } from '@mui/system';
import { Typography } from '@mui/material';

import styles from './error4xx.module.scss';

export const Error4xx = () => (
  <Stack className={styles.container} data-testid="component-error-4xx">
    <Typography variant="h1">Sorry, the page you are looking for doesn&apos;t exist!</Typography>
  </Stack>
);
